<div class="detail-sidebar-container">
  <div class="detail-sidebar">
    <app-detail-sidebar [title]="title" [items]="items"></app-detail-sidebar>
  </div>
  <div class="details-content">
    <router-outlet></router-outlet>
  </div>
</div>
